var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallLogsEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 23.5614,
    rx: 1.5,
    fill: "white",
    stroke: "#C5C5C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 14.0001C14.9206 14.0001 15.6668 13.2304 15.6668 12.2808C15.6668 11.3313 14.9206 10.5615 14.0002 10.5615C13.0797 10.5615 12.3335 11.3313 12.3335 12.2808C12.3335 13.2304 13.0797 14.0001 14.0002 14.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 14.0001C20.7536 14.0001 21.4998 13.2304 21.4998 12.2808C21.4998 11.3313 20.7536 10.5615 19.8332 10.5615C18.9127 10.5615 18.1665 11.3313 18.1665 12.2808C18.1665 13.2304 18.9127 14.0001 19.8332 14.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 14.0001C9.08714 14.0001 9.83333 13.2304 9.83333 12.2808C9.83333 11.3313 9.08714 10.5615 8.16667 10.5615C7.24619 10.5615 6.5 11.3313 6.5 12.2808C6.5 13.2304 7.24619 14.0001 8.16667 14.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogsEdit);
export default __webpack_public_path__ + "static/media/call-logs-edit.2832bb87711f53fce57558bb8347895b.svg";
export { ForwardRef as ReactComponent };